export const FETCH_CARD = 'FETCH_CARD'
export const UPDATE_CARD = 'UPDATE_CARD'



// WEBPACK FOOTER //
// ./src/action-types.js